import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loading } from "components/Loading/loading";
import { useEffect, useState } from "react";
import { trans } from "utils/helpers";
import { checkForm, deleteForm, getAllForms, getDataGridAvailable, getDictionaryAvailable } from "../api";
import { DictionaryAvailable, InputAvailable } from "./InputAvailable";
import { InputTypes } from "types/enum";
import { ModalForm } from "components/ModalForm/ModalForm";
import { DataCollectionForm } from "./DataCollection/DataCollectionForm";
import { DataGridForm } from "./DataGridForm/DataGridForm";
import { DefaultSetting } from "./DefaultSetting";
import { GUID_EMPTY } from "utils/constants";

interface ListToolBarPropsType {
  selectInput: (e: any ,event: any) => void;
  setToolBarType: (e: any) => void;
  setFormMode: (e: any) => void;
  setShowCreateForm: (e: any) => void;
  setDefaultSettingObj: (e: any) => void;
  handleReset: () => void;
  getFormByNameAsync: (e: any, mode? , endfunc?) => void;
  getFormByNameDownloadAsync?:(e: any) => void
  toolBarType: any;
  disableMode: any;
  formMode: any;
  informationForm: any;
  createGrid?:boolean,
  reload?:boolean
gridPageMode?:any
selectedObj?:any

}

export const ListToolBar = ({
  selectInput,
  setToolBarType,
  setFormMode,
  getFormByNameAsync,
  getFormByNameDownloadAsync,
  setShowCreateForm,
  setDefaultSettingObj,
  handleReset,
  toolBarType,
  disableMode,
  formMode,
  informationForm,
  createGrid,
  reload,
  gridPageMode,
selectedObj

}: ListToolBarPropsType) => {
  const [userChanges, setUserChanges] = useState({});
  const [formsLoading, setFormLoading] = useState<boolean>(true);
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [forms, setForms] = useState<any>();
  const [dataDictionary, setDataDictionary] = useState<any>([]);
  const [showDataCollectForm, setShowDataCollectForm] = useState(false);
  const [changed,setChanged]=useState(false)
  const [showDataGridForm, setShowDataGridForm] = useState(false);
  const [selectedDataCollectionEditing,setSelectedDataCollectionEditing]=useState<any>()
  const [dataGridFormMode,setDataGridFormMode]=useState<any>(gridPageMode?gridPageMode:'create')
  const [showDefaultSetting, setShowDefaultSetting] = useState<boolean>(false);

    const handleDeleteForms = async (formKey) => {
    try {
      const res = await checkForm(formKey);
      if (res) {
        await deleteForm(formKey);
        setForceUpdate(!forceUpdate);
        handleReset()
      }
    } catch (err: any) {}
  };

   async function getFormsAsync() {
    setFormLoading(false);
    try {
      const respons = await getAllForms();
      if(respons.Data.TotalRecords!=0 && respons.Data.Data.length>0)
      setForms(respons.Data.Data);
    } catch (err: any) {}
    setFormLoading(true); 
  }
    const getDictionaryAvailableAsync = async () => {
      const respons = await getDictionaryAvailable();
      const respons2 = await getDataGridAvailable();
      
      let data = [
        ...DictionaryAvailable,
          ...(respons.Data.Data.length>0 && respons.Data?.TotalRecords!=0 ?respons.Data.Data.map((item) => {
            return {
              typeName: item.Title,
              KeyId: item.Id ,
              typeNameEn: item.SystemKey,
              SystemKey: item.SystemKey,
              type: InputTypes.DynamicDictionary,
              backendType: "string",
            };
          }):[]),
          ... respons2.Data.map((item) => {
            return {
              typeName: item.Title,
              KeyId:item.Id,
              typeNameEn: item.SystemKey,
              SystemKey: item.SystemKey,
              type: InputTypes.dataGrid,
              backendType: "",
            };
          }),
        ]
   
      setDataDictionary(data);
        try {
      } catch (error) {}
    };

  useEffect(() => {
  }, []);

  useEffect(() => {
    getFormsAsync();
     getDictionaryAvailableAsync();
  }, [forceUpdate,reload]);

  return (

    <>

      {showDefaultSetting && (
        <ModalForm
          title={trans("Setting")}
          show={showDefaultSetting}
          onHide={() => {
            setShowDefaultSetting(false);
          }}
        >
          <DefaultSetting
            mode={"create"}
            onHide={() => {
              setShowDefaultSetting(false);
            }}
            reload={()=>{getDictionaryAvailableAsync();getFormsAsync()}}
            handleSettingForm={(e) => {
              setDefaultSettingObj(e);
            }}
            obj={localStorage.getItem("DefaultSettingFormBuilder") ? JSON.parse(localStorage.getItem("DefaultSettingFormBuilder")+"")  : {}}
          />
        </ModalForm>
      )}

          {showDataCollectForm && (
            <ModalForm
              title={trans("add")+" "+trans("databox") }
              modalProfileKey="databox"
              show={showDataCollectForm}
              onHide={() => {
                if(changed){
                    getDictionaryAvailableAsync()
                }
                setShowDataCollectForm(false);
              }}
            >
              <DataCollectionForm
                mode={"create"}
                onHide={() => {
                  setShowDataCollectForm(false);
                }}
                setChanged={setChanged}          
              />
            </ModalForm>
          )}
                  {showDataGridForm && (
        <ModalForm
          title={trans("DataGridForm")}
          show={showDataGridForm}
          onHide={() => {
            setShowDataGridForm(false);
          }}
        >
          <DataGridForm
            mode={dataGridFormMode}
            onHide={() => {
              setShowDataGridForm(false);
            }}
            realod={()=>setForceUpdate(!forceUpdate)}
            DynamicObj={selectedDataCollectionEditing??selectedObj}

          />
        </ModalForm>
      )}


            <div
          className={`d-flex flex-column justify-content-between position-relative p-0 col-2 glassBox formBuilder__toolBar border-0 ${
            (disableMode) && "disableMode"
          } `}
        >
          <div className="">
            <div className={`d-flex formBuilder__toolBar__header `}>
   {    !createGrid    ?   <div
                onClick={() => {
                  setToolBarType(createGrid ?1 :0);
                  getFormsAsync();
                }}
                className={`formBuilder__toolBar__header__title text-center p-2 w-100 ${
                  !toolBarType
                    ? " color_text_black"
                    : formMode != "view"
                    ? "color_text_primary formBuilder__toolBar__header__disableTitle"
                    : "color_text_primary formBuilder__toolBar__header__disableTitle   "
                }`}
              >
                {trans("forms")}
              </div>
            :<></>  
            }
              <div
                onClick={() => {
                  setToolBarType(2);
                  if (informationForm != null) {
                    if (formMode != "view") {
                    }
                  }
                }}
                className={`formBuilder__toolBar__header__title text-center p-2 w-100 ${
                  toolBarType == 2
                    ? "color_text_black"
                    : formMode != "view"
                    ? "color_text_primary formBuilder__toolBar__header__disableTitle"
                    : " color_text_primary formBuilder__toolBar__header__disableTitle"
                }`}
              >
                {trans("databox")}
              </div>
              <div
                onClick={() => {
                  setToolBarType(1);
                  if (informationForm != null) {
                    if (formMode != "view") {
                    }
                  }
                }}
                className={`formBuilder__toolBar__header__title text-center p-2 w-100 ${
                  toolBarType == 1
                    ? "color_text_black"
                    : formMode != "view"
                    ? "color_text_primary formBuilder__toolBar__header__disableTitle"
                    : " color_text_primary formBuilder__toolBar__header__disableTitle"
                }`}
              >
                {trans("toolBox")}
              </div>
            </div>
            <ul
              className={` posiion-relative p-1 formBuilder__toolBar__body position-relative`}
            >
              {toolBarType ? (
                <>
                  {toolBarType == 1
                    ? InputAvailable.map(
                        (e: any) =>
                          e.typeName != "PositionDictionary" && (
                            <li
                              className=""
                              onMouseDown={(event) => {
                                if (formMode != "view") selectInput(e, event);
                              }}
                            >
                              <div className=" glassBox p-2 border border-1 m-1 d-flex justify-content-between align-items-center formBuilder__toolBar__body__items">
                                <div className="showDots">
                                  {trans(e.typeName)}
                                </div>
                                <FontAwesomeIcon icon={e.icon} />
                              </div>
                            </li>
                          )
                      )
                    : dataDictionary.map(
                        (e: any) =>
                          e.typeName != "PositionDictionary" && (
                            <li
                              className=""
                            >
                              <div className=" glassBox  p-2 border border-1 m-1 d-flex justify-content-between align-items-center formBuilder__toolBar__body__items">
                                <div className="showDots w-100 row justify-content-between">
                                  <div className="col-9"
                                      onMouseDown={(event) => {
                                if (formMode != "view") selectInput(e, event);
                              }}
                                  >
                                  {trans(e.typeName)}</div>
                              {e.type==InputTypes.dataGrid &&    <div 
                                  //  onClick={()=>{
                                  //   setShowDataGridForm(true);
                                  //   setDataGridFormMode('edit')
                                  //   setSelectedDataCollectionEditing(e)
                                  //  }}
                                  className="col-auto text-start px-0" style={
                                    {cursor:'pointer'}
                                  }>
                                <FontAwesomeIcon icon={'table'} /></div>}
                                </div>
                              </div>
                            </li>
                          )
                      )}
                </>
              ) : (
                <>
                  {
                  !createGrid?
                  formsLoading ? (
                    <ul className="">
                      {forms?.map((form, index) => (
                        <li
                          className={`m-2 p-2 glassBox formBuilder__toolBar__body__form ${
                            informationForm?.SystemKey == form.FormKey
                              ? " formBuilder__toolBar__body__form__active"
                              : ""
                          }`}
                          onClick={() => {
                            getFormByNameAsync(form.FormKey);
                             setFormMode("view");
                          }}
                        >
                          <div>
                            <div className="showDots formBuilder__toolBar__body__form__title">
                              {form?.FormTitle}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between">
                            <div className="text-muted showDots formBuilder__toolBar__body__form__sub">
                              {form?.FormKey}
                            </div>
                            <div className="d-flex">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // getFormByNameAsync(form.FormKey, "copy");
                           getFormByNameDownloadAsync && getFormByNameDownloadAsync(form.Id);
                                }}
                                className="btn btn-sm ms-1 btn-warning d-flex justify-content-center align-items-center customBtnSize"
                              >
                                <FontAwesomeIcon icon={["fas", "download"]} />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  getFormByNameAsync(form.FormKey);
                                  setFormMode("view");
                                }}
                                className="btn btn-sm ms-1 btn-success d-flex justify-content-center align-items-center customBtnSize"
                              >
                                <FontAwesomeIcon icon={["fas", "eye"]} />
                              </button>
                              {formMode == "view" && (
                                <>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      getFormByNameAsync(form.FormKey , null , ()=>{  setFormMode("edit");
                                        setShowCreateForm(true)} );

                                    }}
                                    className="btn btn-sm ms-1 btn-primary d-flex justify-content-center align-items-center customBtnSize"
                                  >
                                    <FontAwesomeIcon icon={["fas", "edit"]} />
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteForms(form.FormKey);
                                    }}
                                    className="btn btn-sm ms-1 btn-danger d-flex justify-content-center align-items-center customBtnSize"
                                  >
                                    <FontAwesomeIcon icon={["fas", "trash"]} />
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ): <Loading />: (
                    <></>
                  )}
                </>
              )}
            </ul>
          </div>
          {!toolBarType && (
            <div className="d-flex">
              <button
                disabled={formMode != "view" ? true : false}
                onClick={() => {
                  setShowDefaultSetting(true);
                }}
                className="d-flex align-items-center justify-content-center btn btn-primary w-25 ms-1 "
              >
                <FontAwesomeIcon icon={["fas", "gear"]} />
              </button>
              <button
                disabled={formMode != "view" ? true : false}
                onClick={() => {
                   handleReset()
                  setShowCreateForm(true);
                  setFormMode("create");
                }}
                className="btn btn-primary w-75 "
              >
                {trans("createform")}{" "}
              </button>
            </div>
          )}

          {toolBarType == 2 && !createGrid && (
            <div className="d-flex  row justify-content-center">
              <div className="col-9">
              <button
                onClick={() => {
                  setShowDataCollectForm(true);
                  //  setFormMode("create");
                
                }}
                style={{fontSize:'12px'}}
                className="btn px-0 btn-primary w-100 "
              >
                {trans('DataSetProperties')}
              </button>
              </div>
{/*             
            <div className="col-6">
                <button
                    onClick={() => {
                    
                      setShowDataGridForm(true);
                      setDataGridFormMode("create");
                    }}
                    style={{fontSize:'12px'}}
                    className="btn px-0 btn-primary w-100 "
                  >
                    {trans('DataTables')}
                </button>
            </div> */}
        
            </div>
          )}
        </div>
    </>
  );
};
